import { useState } from 'react'

/**
 * Hook to chunk data into smaller pieces. Useful for gradual rendering of large data sets.
 */
export function useChunkedData<T>(data: T[], chunkSize: number) {
	const [chunks, setChunks] = useState(() => {
		if (!data) return []
		return data.slice(0, chunkSize)
	})

	function addChunk() {
		const newChunk = data.slice(chunks.length, chunks.length + chunkSize)

		setChunks(prevChunk => [...prevChunk, ...newChunk])
	}

	return [chunks, addChunk] as const
}
